import collapse from '@alpinejs/collapse';
import Alpine from 'alpinejs';
import { agileFormContact } from './modules/AgileFormContact';
import { agileFormEiws } from './modules/AgileFormEiws';
import { agileFormPower } from './modules/AgileFormPower';
import { agileFormYellowBanner } from './modules/agileFormYellowBanner';
import { genericAgileForm } from './modules/genericAgileForm';

Alpine.plugin(collapse);

window.Alpine = Alpine;

Alpine.start();

window.genericAgileForm = genericAgileForm;
window.agileFormYellowBanner = agileFormYellowBanner;
window.agileFormPower = agileFormPower;
window.agileFormContact = agileFormContact;
window.agileFormEiws = agileFormEiws;

/**
 * old stuff
 */

import { genericAgileAction, postGenericAgile } from './agile';
import { AgileLoginInit } from './modules/AgileLogin';
import { werkboekenInit } from './modules/Werkboeken';
import { agileSuccess } from './modules/agileHelper';
import { desktopPopup, mobilePopup } from './popup';

document.addEventListener('DOMContentLoaded', () => {
    // formFrontPage();
    // strategiekaart();
    console.log('DOMContentLoaded');
    werkboekenInit();
    popupKennisbank();
    desktopPopup();
    mobilePopup();
    AgileLoginInit();
    // genericAgileListeners();

    if (typeof _agile !== 'undefined') {
        console.log(_agile.get_email());
    }
});

// Is called after jQuery steps is initiated
window.rekentoolListeners = function () {
    console.log('rekentoolListeners');
    const agileForm = document.querySelector('.agile-form-rekentool');
    console.log('rekentoolListeners');
    if (agileForm) {
        console.log('agileForm');
        genericAgileAction(
            agileForm,
            () => {},
            () => {}
        );
    }
};

function popupKennisbank() {
    checkEmail();

    var acceptCookiesButton = document.getElementById('acceptCookiesKennisbank');
    if (acceptCookiesButton) {
        acceptCookiesButton.addEventListener('click', function () {
            if (window.location.href.includes('?')) {
                window.location.href = window.location.href + '&cookies=ok';
            } else {
                window.location.href = window.location.href + '?cookies=ok';
            }
        });
    }

    var downloadKennisbank = document.getElementById('downloadKennisbank');
    if (downloadKennisbank) {
        downloadKennisbank.addEventListener('click', function () {
            var email = document.getElementById('email-input').value;
            var re = /\S+@\S+\.\S+/;

            if (re.test(email)) {
                // document.getElementById("emailform").submit();
                setEmail(email);
            } else {
                document.getElementById('emailDialog').classList.add('show');
            }
        });
    }

    // var closeEmail = document.getElementById("closeEmail");
    // if (closeEmail) {
    //   closeEmail.addEventListener("click", function() {
    //     document.getElementById("emailOverlay").classList.add("hidden2");
    //     document.getElementById("helaasOverlay").classList.remove("hidden");
    //   });
    // }

    var terugHelaas = document.getElementById('terugHelaas');
    if (terugHelaas) {
        terugHelaas.addEventListener('click', function () {
            document.getElementById('emailOverlay').classList.remove('hidden2');
            document.getElementById('helaasOverlay').classList.add('hidden');
        });
    }

    var downloadenHelaas = document.getElementById('downloadenHelaas');
    if (downloadenHelaas) {
        downloadenHelaas.addEventListener('click', function () {
            document.getElementById('helaasOverlay').classList.add('hidden');
            document.getElementsByTagName('BODY')[0].classList.remove('no-scroll');
            var link = getQueryVariable('q');
            if (link) {
                window.location.href = window.atob(link);
            }
        });
    }

    var closeCookies = document.getElementById('closeCookies');
    if (closeCookies) {
        closeCookies.addEventListener('click', function () {
            document.getElementById('cookieOverlay').classList.add('hidden');
            document.getElementsByTagName('BODY')[0].classList.remove('no-scroll');
            if (window.location.href.includes('?')) {
                window.location.href = window.location.href + '&cookies=not_ok';
            } else {
                window.location.href = window.location.href + '?cookies=not_ok';
            }
        });
    }
}

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return false;
}

function setEmail(emailadres) {
    document.getElementById('ripple').classList.remove('hidden');
    document.getElementById('verzenden').classList.add('hidden');
    if (typeof _agile !== 'undefined') {
        _agile.set_email(emailadres);
    }
    agileSuccess({
        email: emailadres,
    });
    postGenericAgile(emailadres, '', '', '', ['Nieuwsbrief', 'Document'], removeEmailOverlay(), removeEmailOverlay());
}

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

function checkEmail() {
    // if agile isnt loaded yet retry
    if (typeof _agile === 'undefined') {
        sleep(100).then(() => checkEmail());
    } else {
        _agile.get_contact(
            _agile.get_email({
                success: function (data) {
                    if (data.email == 'null' || data.email == null) {
                        addEmailOverlay();
                    }
                },
                error: function (data) {
                    addEmailOverlay();
                },
            }),
            {
                success: function (data) {
                    document.getElementsByTagName('BODY')[0].classList.remove('no-scroll');
                    removeEmailOverlay();
                },
                error: function (data) {
                    addEmailOverlay();
                },
            }
        );
    }

    // if no cookies and link redirect
    var cookie = getQueryVariable('cookies');
    if (cookie == 'not_ok' || document.cookie.includes('place_cookies=not_ok')) {
        var link = getQueryVariable('q');
        if (link) {
            window.location.href = window.atob(link);
        }
    }
}

function removeEmailOverlay() {
    var emailOverlay = document.getElementById('emailOverlay');
    if (emailOverlay) {
        emailOverlay.classList.add('hidden');
        document.getElementsByTagName('BODY')[0].classList.remove('no-scroll');
    }
    var link = getQueryVariable('q');
    if (link) {
        window.location.href = window.atob(link);
    }
}

function addEmailOverlay() {
    var emailOverlay = document.getElementById('emailOverlay');
    if (emailOverlay) {
        emailOverlay.classList.remove('hidden');
        document.getElementsByTagName('BODY')[0].classList.add('no-scroll');
    }
}
